import { config } from '@fortawesome/fontawesome-svg-core';

// Shared/tailwindcss/tailwind.css imports Font Awesome's stylesheet inside a
// cascade layer. The copy svg-core injects at runtime on the first icon render
// would sit outside every layer and beat Tailwind utilities, so every module
// that imports tailwind.css imports this first.
config.autoAddCss = false;
